export type NutrientKey =
  | 'hmo'
  | 'igg'
  | 'nucleotid'
  | 'dam_whey'
  | 'canxi'
  | 'vitamin_d3k2'
  | 'sua'
  | 'trung'
  | 'chuoi'
  | 'rau_cu';

export interface NutrientDef {
  key: NutrientKey;
  value: number;
  weight: number;
  label: string;
  color: number;
  tooltip?: string;
}

export const NUTRIENTS: Record<NutrientKey, NutrientDef> = {
  hmo: {
    key: 'hmo',
    value: 15,
    weight: 10,
    label: 'HMO',
    color: 0x9c5bd9,
    tooltip: 'HMO giúp tăng đề kháng đường ruột',
  },
  igg: {
    key: 'igg',
    value: 20,
    weight: 8,
    label: 'IgG',
    color: 0x3b9f4a,
    tooltip: 'IgG là kháng thể từ sữa non, bảo vệ bé khỏi bệnh',
  },
  nucleotid: {
    key: 'nucleotid',
    value: 15,
    weight: 10,
    label: 'Nucleotid',
    color: 0xe8b528,
    tooltip: 'Nucleotid hỗ trợ phát triển hệ miễn dịch',
  },
  dam_whey: {
    key: 'dam_whey',
    value: 12,
    weight: 12,
    label: 'Đạm Whey',
    color: 0x4a90d9,
    tooltip: 'Đạm Whey dễ tiêu hóa, giàu acid amin thiết yếu',
  },
  canxi: {
    key: 'canxi',
    value: 10,
    weight: 12,
    label: 'Canxi',
    color: 0xf5f5f5,
    tooltip: 'Canxi giúp xương và răng chắc khỏe',
  },
  vitamin_d3k2: {
    key: 'vitamin_d3k2',
    value: 15,
    weight: 8,
    label: 'Vitamin D3 & K2',
    color: 0xffa726,
    tooltip: 'D3 & K2 tăng hấp thu canxi vào xương',
  },
  sua: { key: 'sua', value: 5, weight: 15, label: 'Sữa', color: 0xffffff },
  trung: { key: 'trung', value: 5, weight: 8, label: 'Trứng', color: 0xffe082 },
  chuoi: { key: 'chuoi', value: 5, weight: 7, label: 'Chuối', color: 0xffeb3b },
  rau_cu: { key: 'rau_cu', value: 5, weight: 5, label: 'Rau củ', color: 0x66bb6a },
};

export const DIELAC_NUTRIENT_KEYS = (Object.keys(NUTRIENTS) as NutrientKey[]).filter(
  (k) => NUTRIENTS[k].tooltip !== undefined,
);

export const ALL_NUTRIENT_KEYS = Object.keys(NUTRIENTS) as NutrientKey[];

export function isDielacNutrient(key: NutrientKey): boolean {
  return NUTRIENTS[key].tooltip !== undefined;
}

export function weightedEntries(): ReadonlyArray<{ key: NutrientKey; weight: number }> {
  return ALL_NUTRIENT_KEYS.map((key) => ({ key, weight: NUTRIENTS[key].weight }));
}
